import type { QueryClient } from '@tanstack/react-query';

import { TaskData } from 'chaika-frontend-types/frontend-cms';

import { isDefined } from '@utils/isDefined';
import { userPracticeAssistantQueryOptions } from '@user/queries/userPracticeAssistantQueries';

import type { TaskAssistantData } from '../types';

export async function loadTaskAssistants(
    authUserId: string,
    task: TaskData | undefined,
    queryClient: QueryClient,
): Promise<TaskAssistantData | undefined> {
    if (!isDefined(task)) {
        return undefined;
    }

    const resolveActiveAssistantId = async (userId?: string): Promise<string | undefined> => {
        if (!isDefined(userId)) {
            return undefined;
        }

        const assistants = await queryClient.fetchQuery(userPracticeAssistantQueryOptions.byUserId(userId));

        return assistants.find(({ id }) => id === authUserId)?.id;
    };

    const [authorsAssistantId, requestersAssistantId] = await Promise.all([
        resolveActiveAssistantId(task.authorId),
        resolveActiveAssistantId(task.requesterId),
    ]);

    // executorsAssistantId в оригинале (TaskStore.setAssistantsData) не резолвился — сохраняем пустой список.
    return {
        authorsAssistantId,
        requestersAssistantId,
        executorsAssistantId: [],
    };
}
